const CompareCreativesInterface = {
  high: [],
  low: []
};
export default CompareCreativesInterface;
